import { OnboardingRoute } from "../OnboardingRoute";
import CardComponent from "./index.component";

export default class Card extends OnboardingRoute {
    constructor() {
        super("ECPCard");
    }

    component = CardComponent;
}